import { render } from "./GoToTop.vue?vue&type=template&id=0d087606&scoped=true"
import script from "./GoToTop.vue?vue&type=script&lang=js"
export * from "./GoToTop.vue?vue&type=script&lang=js"

import "./GoToTop.vue?vue&type=style&index=0&id=0d087606&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d087606"]])

export default __exports__